export default __webpack_public_path__ + "static/media/addservice.5d0fcb09.jpg";